import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";

import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {IonicStorageModule} from "@ionic/storage";
import {Http, HttpModule} from "@angular/http";
import {AuthConfig, AuthHttp} from "angular2-jwt";
import {AuthService} from "./auth/auth.service";
import {OpenPayService} from "./openpay/openpay.service";
import {AuthStorageService} from "./auth/auth-storage.service";
import {AuthGuard} from "./auth/auth-guard";
import {AuthResolver} from "./auth/auth-resolver";
import {LocalStorageModule} from "angular-2-local-storage";
import {DateTimeFormatting} from "./config/date-formatting.service";
import {Events} from "./events";
// Components
import {NAV_DROPDOWN_DIRECTIVES} from "./components/nav-dropdown.directive";
import {SIDEBAR_TOGGLE_DIRECTIVES} from "./components/sidebar.directive";
import {AsideToggleDirective} from "./components/aside.directive";
import {BreadcrumbsComponent} from "./components/breadcrumb.component";
// Layouts
import {AppLayoutComponent} from "../layouts/app-layout/app-layout.component";
import {SimpleLayoutComponent} from "../layouts/simple-layout/simple-layout.component";
import {LandingLayoutComponent} from "../layouts/landing-layout/landing-layout.component";
import {HeaderComponent} from "../layouts/shared/header/header.component";
import {SimpleHeaderComponent} from "../layouts/shared/simple-header/simple-header.component";
import {SidebarComponent} from "../layouts/shared/sidebar/sidebar.component";
import {FooterComponent} from "../layouts/shared/footer/footer.component";
import {PopoverModule} from "ngx-bootstrap/popover";
import {CarouselModule} from "ngx-bootstrap/carousel";
import {VerificationComponent} from "../juegos/components/verification/verification.component";
import {ModalModule} from "ngx-bootstrap/modal";
import {GrowlModule} from "primeng/primeng";
//import {TooltipModule} from 'primeng/primeng';
import {LaddaModule} from "angular2-ladda";
import {EmailSuccessComponent} from "../juegos/components/verification/email-success.component";

import {CustomerService} from "./customer/customer.service";
import {GenericService} from "./components/generics.service";

import {FormsExtensionsModule} from "../shared/forms/forms-extensions.module";
import {AccountModule} from "../account/account.module";

import {SplitLastPipe} from "./components/split-last.pipe";
import {GameVerificationService} from "./verify/game-verification-service";


export function getAuthHttp(http: Http, storage: AuthStorageService) {
    return new AuthHttp(new AuthConfig({
        globalHeaders: [{'Content-Type': 'application/json'}],
        tokenGetter: storage.getAccessToken.bind(storage),
        noJwtError: true
    }), http);
};

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpModule,
        IonicStorageModule.forRoot(),
        LocalStorageModule.withConfig({
            prefix: 'ganalottodo-app',
            storageType: 'localStorage'
        }),
        PopoverModule.forRoot(),
        CarouselModule.forRoot(),
        LaddaModule.forRoot({}),
        FormsExtensionsModule,
        AccountModule,
        GrowlModule,
        ModalModule,

    ],
    declarations: [
        NAV_DROPDOWN_DIRECTIVES,
        BreadcrumbsComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        AppLayoutComponent,
        SimpleLayoutComponent,
        LandingLayoutComponent,
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        SimpleHeaderComponent,
        EmailSuccessComponent,
        VerificationComponent,
        SplitLastPipe
    ],
    exports: [
        NAV_DROPDOWN_DIRECTIVES,
        BreadcrumbsComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        AppLayoutComponent,
        SimpleLayoutComponent,
        LandingLayoutComponent,
        HeaderComponent,
        SimpleHeaderComponent,
        SidebarComponent,
        FooterComponent,
        PopoverModule,
        EmailSuccessComponent,
        VerificationComponent
    ],
    providers: [
        AuthService,
        OpenPayService,
        AuthStorageService,
        DateTimeFormatting,
        AuthGuard,
        AuthResolver,
        CustomerService,
        GenericService,
        Events,
        GameVerificationService,
        {
            provide: AuthHttp,
            useFactory: getAuthHttp,
            deps: [Http, AuthStorageService]
        }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error(
                'CoreModule is already loaded. Import it in the AppModule only');
        }
    }

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule
        };
    }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/core.module.ts